/* ============================================================
   Running Auctions Grid → "Vault Top 5" — DOM cleanup (single file)
   ------------------------------------------------------------
   Companion to running-auctions-grid-vault-top5.css. Turns the
   app-rendered rows into the exact copy shown on the Vault Top 5
   reference (https://fidgetvault.com/collections/auctions#fv-top-sales):

     app writes:                    this file leaves:
     "USD $125.00 is the Highest Bid"  →  "USD $125.00"
     "34 bids"                         →  "34"

   It observes the grid and re-cleans rows automatically when
   cards are loaded via "Load More" or when a live bid updates a
   row — no refresh needed.

   HOW TO USE (client store):
   1. Copy this file into your theme's "Assets" and load it
      alongside running-auctions-grid-vault-top5.css — e.g. paste
      into the theme's custom scripts box, or add
      <script src="{{ 'running-auctions-grid-vault-top5.js' | asset_url }}" defer></script>
      in theme.liquid before </body>.
   2. No other changes needed. Load order does not matter; it
      waits for cards to appear and cleans them up.
   ============================================================ */
(function () {
  'use strict';

  var CARD_SELECTOR = '.rag-section .rag-card';
  var TARGET_SELECTOR = '.rag-card__highest, [data-rag-bid-count]';

  /* Column header row injected at the top of the table, matching
     the reference "Vault Top 5" header (# / Item / Final price /
     Total bids). A real row (instead of a CSS pseudo) lets each
     label be centered over its own column and always sit at the
     top of the grid. */
  var HEADER_HTML =
    '<span class="rag-vault-header__rank" role="columnheader">#</span>' +
    '<span class="rag-vault-header__item" role="columnheader">Item / Maker</span>' +
    '<span class="rag-vault-header__price" role="columnheader">Final price</span>' +
    '<span class="rag-vault-header__bids" role="columnheader">Total bids</span>';

  /* Remove the verbose suffixes the app appends, so the cells
     read exactly like the reference table. */
  function cleanText(value) {
    if (!value) return value;
    return value
      .replace(/\s+is the Highest Bid\s*$/i, '') /* "USD $125.00 is the Highest Bid" → "USD $125.00" */
      .replace(/\s+bids?\s*$/i, '');             /* "34 bids" → "34" */
  }

  function processCard(card) {
    if (!card || !card.querySelectorAll) return;
    var els = card.querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cleaned = cleanText(el.textContent);
      if (cleaned !== el.textContent) el.textContent = cleaned;
    }
  }

  function processGrid(grid) {
    if (!grid || !grid.querySelectorAll) return;
    var cards = grid.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) processCard(cards[i]);
  }

  function ensureHeader(grid) {
    if (!grid || !grid.querySelector) return;
    if (grid.querySelector(':scope > .rag-vault-header')) return;
    var header = document.createElement('div');
    header.className = 'rag-vault-header';
    header.setAttribute('role', 'row');
    header.setAttribute('aria-label', 'Top auctions');
    header.innerHTML = HEADER_HTML;
    grid.insertBefore(header, grid.firstChild);
  }

  /* Give the section title header (.rag-header) the #fv-top-sales-new
     anchor so the "Top 5" nav link scrolls to this element. We can't
     put it on .rag-section itself — the app reads that element's own
     id to initialize — so the header (top of the panel) is the target. */
  function ensureAnchor(section) {
    if (!section || !section.querySelector) return;
    var header = section.querySelector('.rag-header');
    if (!header || header.id === 'fv-top-sales-new') return;
    header.id = 'fv-top-sales-new';
  }

  function processAll() {
    var sections = document.querySelectorAll('.rag-section');
    for (var i = 0; i < sections.length; i++) {
      ensureAnchor(sections[i]);
      var grids = sections[i].querySelectorAll('.rag-grid');
      for (var j = 0; j < grids.length; j++) {
        ensureHeader(grids[j]);
        processGrid(grids[j]);
      }
    }
  }

  function isTarget(el) {
    return el && el.matches && el.matches(TARGET_SELECTOR);
  }

  /* Re-run whenever cards are added (initial render, Load More)
     or when the app rewrites a price/bid text after a bid. */
  function startObserver() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      var structureChanged = false;

      for (var m = 0; m < mutations.length; m++) {
        var mutation = mutations[m];

        if (mutation.type === 'childList') {
          structureChanged = true;
          var nodes = mutation.addedNodes;
          for (var n = 0; n < nodes.length; n++) {
            var node = nodes[n];
            if (node.nodeType !== 1) continue; /* element nodes only */

            if (node.matches && node.matches(CARD_SELECTOR)) {
              processCard(node);
            } else if (node.querySelectorAll && node.querySelectorAll(CARD_SELECTOR).length) {
              processGrid(node);
            }
          }
        } else if (mutation.type === 'characterData') {
          var el = mutation.target.parentElement;
          if (isTarget(el)) processCard(el.closest(CARD_SELECTOR));
        }
      }

      /* Any DOM structure change (render, Load More, sort, empty
         state) → re-ensure the header row and re-clean all rows. */
      if (structureChanged) processAll();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function init() {
    processAll();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
